import React from "react";
import formatDate from "helpers/format-date";
import { useSelector } from "react-redux";
import { getDayName } from "helpers/format-date";
import obtainOrderInfo from "utils/obtain-order-info";
import TruckIcon from "assets/images/order-truck.png";
import { useGlobalContext } from "context/global";

const DispatchedOrder = () => {
	const { translation, language } = useGlobalContext();
	const { latestSubOrder } = useSelector(state => state.account.profile);
	const { totalWeight, nextBillingDate, chargeOffsetDays } = useSelector((state) => state.account.subscription);
	const { date, isDispatched, isTrackable, show } = obtainOrderInfo(nextBillingDate, chargeOffsetDays, latestSubOrder);

	if (!show) return null;

	const totalQty = latestSubOrder?.totalQuantity || totalWeight;

	return (
		<div className="flex flex-col border-t border-gray-200 p-4 w-full md:px-8 gap-3 my-2 group">
			{isDispatched && (
				<div className="text-[#108610]">
					<span>{translation.subscription?.next_order}</span>
				</div>
			)}
			<div className="flex justify-between items-center">
				<div className="flex flex-col">
					<span>{getDayName(date, language)}, {formatDate(date, language)}</span>
					<span className="text-gray-500">
						{totalQty} {totalQty > 1 ? translation.cart?.products : translation.cart?.product}
						<br></br>
					</span>
					{isTrackable && latestSubOrder?.fulfillments?.length > 0 &&
						<a href={latestSubOrder?.fulfillments[0]?.trackingInfo[0]?.url} className="flex flex-row">
							<img className="size-6" src={TruckIcon} alt="Truck" role="presentation" aria-hidden="true" />
							<span className="ml-1">{translation?.subscription?.track_delivery}</span>
						</a>}
				</div>
				<span className="text-green-500 text-small cursor-default">
					{translation.subscription.status["scheduled"]}
				</span>
			</div>
		</div>
	);

};

export default DispatchedOrder;